import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import db from "../firebase";
import "../Detail.css";
import Header from "./Header";

function Detail() {
  const location = useLocation();
  const { id } = location.state || {};
  const [cocktail, setCocktail] = useState(null);

  useEffect(() => {
    const fetchCocktail = async () => {
      const docRef = doc(db, "items", id);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        setCocktail({ id: docSnap.id, ...docSnap.data() });
      } else {
        console.log("カクテルが見つかりません");
      }
    };
    
    fetchCocktail();
    
  }, [id]);


  if (!cocktail) {
    return <div>読み込み中...</div>;
  }

  return (
    <div className="dtall">
      <h2>{cocktail.name}</h2>
      <img
        src={cocktail.image}
        alt={cocktail.name}
      />
      <div class="detail-cocktail">
        <div class="point">
          <p  className="span-contents">ベースのお酒:  {cocktail.base}
          </p>
          <p className="span-contents">アルコール度数:  {cocktail.alcoholContent}
          </p>
          <p className="span-contents">炭酸:  {cocktail.carbonation}
            
          </p>
          <p className="span-contents">味:  {cocktail.taste}
          </p>
        </div>
        <p className="recipe-border">
          材料{cocktail.ingredients.map((ingredient)=>(<span className="span-ingredient"><li>{ingredient}</li></span>))}
        </p>
        <p className="making-border">作り方{cocktail.recipe.map((recipes)=>(<span><li>{recipes}</li></span>))}</p>
        {/* {cocktail.recipe.map((recipes)=>(<span><li>{recipes}</li></span>))} */}
        <p className="recipe-border">説明<br/>{cocktail.description}</p>
      </div>
    </div>
  );
}

export default Detail;
